import { CREDIT_FIELDS } from '@/pages/ReceivePayments/constants';

export default [
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
  {
    key: 'Id',
    field: CREDIT_FIELDS.ID,
    title: ' Id',
    label: 'Id',
    sortable: true,
    hidden: false,
  },
  {
    key: 'dateCreated',
    field: CREDIT_FIELDS.CREDIT_DATE,
    title: ' Credit Date',
    label: 'dateCreated',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
  },
  // {
  //   key: 'salesOrderId',
  //   field: CREDIT_FIELDS.SO_NO,
  //   title: ' Sales Order Id',
  //   label: 'salesOrderId',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'Amount',
    field: CREDIT_FIELDS.AMOUNT,
    title: ' Amount',
    label: 'Amount',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
  },
  {
    key: 'Balance',
    field: CREDIT_FIELDS.BALANCE,
    title: ' Balance',
    label: 'Balance',
    cell: 'balance',
    sortable: true,
    hidden: false,
  },
  {
    key: 'payment',
    field: 'payment',
    title: 'Payment',
    label: 'Payment',
    cell: 'editPayment',
    sortable: true,
    hidden: false,
  },
]
